import React from 'react';

import { ELocalStorageKeys } from 'constants/enums';
import { localStorageUtil } from 'utils/localStorageUtil';

import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';

import { User } from '../../common/contracts';

import ProfileDropDown from './ProfileDropDown/ProfileDropDown';

export const Header: React.FC = () => {
  const userDetails = localStorageUtil.getAny<User>(
    ELocalStorageKeys.USER_DETAILS
  );

  return (
    <header className="sticky top-0 bg-white mt-2.5 mb-4 mx-7 flex items-center z-50 pl-[18px]">
      <Breadcrumbs />
      <div className="flex-1 flex justify-end">
        <ProfileDropDown user={userDetails} />
      </div>
    </header>
  );
};
